import { ArnCondition, ArnPredefinedConditionTemplate } from './ArnCondition';
import { ArnConditionOpts } from './ArnConditionOpts';

export interface SpkzConditionOpts extends ArnConditionOpts {
  strategies?: SpkzStrategy[][];
}

export interface SpkzStrategy {
  name: string;
  params: Params;
}

export interface Params {
  minBalance: string;
  tokens: Token[];
}

export interface Token {
  chainId: string;
  networkId: string;
  address: string;
}

export class SpkzCondition implements ArnCondition {
  readonly templateName = ArnPredefinedConditionTemplate.SPKZ;

  constructor(public opts: SpkzConditionOpts) {}
}
